import { FadeUp } from "@/components/FadeUp";
import { SERVICES } from "@/data/site";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Check } from "lucide-react";

export default function Services() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else { window.scrollTo({ top: 0 }); }
  }, [hash]);

  return (
    <div data-testid="services-page" className="section-y">
      <div className="container-x">
        <FadeUp>
          <p className="eyebrow">Capabilities</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mt-4 leading-[0.95] max-w-4xl">
            Six pillars covering the full <span className="italic text-secondary">engineering</span> lifecycle.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-muted-foreground">
            From a single repair part to a complete machined-fabricated-coated-assembled package, our team handles
            it under one roof in Bayswater.
          </p>
        </FadeUp>
      </div>

      <div className="mt-24 divide-y divide-border border-y border-border">
        {SERVICES.map((s, i) => (
          <section key={s.id} id={s.id} className="bg-white">
            <div className="container-x py-20 md:py-28 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="aspect-[4/3] overflow-hidden image-hover">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="lg:col-span-6" data-testid="service-detail-card">
                <span className="editorial-number text-4xl text-accent">{s.number}</span>
                <h2 className="font-serif text-4xl md:text-5xl text-primary mt-3 leading-tight">{s.title}</h2>
                <p className="mt-4 text-lg text-muted-foreground">{s.short}</p>
                <ul className="mt-8 space-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-primary">
                      <Check size={18} className="mt-1 text-accent flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/quote" className="mt-10 inline-flex items-center gap-2 px-5 py-3 bg-primary text-primary-foreground uppercase tracking-[0.18em] text-xs hover:bg-accent transition-colors">
                  Enquire about {s.title}
                </Link>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
